<template>
	<el-card :body-style="{ padding: '0px' }">
		<div slot="header" class="message header">
			<img src="../image/scheduled_messages.svg" class="header-icon">
			<span>
				<span class="head-title-col">Scheduled Messages (Queued)</span>
				<template v-if="getCurrentProvider">
					&nbsp;&nbsp;&middot;
					<span class="provider-name">
						{{ getProviderNameById(getCurrentProvider) }}
					</span>
					
				</template>
				
			</span>
		</div>
		<template v-if="showMultiProviders && patientProviderProfileList.length > 1">
			<div class="doctor-message">
			Select a doctor to view their messages
			</div>
			<ProviderSelect
					class="doctor-select"
					:profile-map="patient.profile_map"
					:initial-select="true"
					@providerSelect="setMessageProvider"></ProviderSelect>
		</template>
		<MessageList
			:messages="patientMessage"
			:patient-name="patient.given_name" :patient-id="patient.id"
			:provider-name="getProviderNameById(messageProvider)">
		</MessageList>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import { mapState, mapActions, mapGetters } from 'vuex'
import MessageList from './List'
import ProviderSelect from './ProviderSelect'
import message from '@/store/module/ws/message'


export default {
	name: 'patient-scheduled-message-card',

	data() {
		return {
			messageProvider: null
		}
	},

	mounted() {
		if(this.patientProviderProfileList && this.patientProviderProfileList.length == 1)
			this.messageProvider = this.patientProviderProfileList[0].provider
	},

	extends: OverviewCard,

	methods: {
		setMessageProvider(provider) {
			this.messageProvider = provider
		}
	},

	computed: {
		...mapGetters('provider', [
			'getPatientMessages',
			'getProviderNameById'
		]),
		patientMessage() {
			var messages = this.getPatientMessages(this.patient.id)
			if (! messages) return []

			return messages
				.map((message) => ({ ...message, mType: 'message'}))
				.filter((message) => {
					if(this.showMultiProviders || this.messageProvider)
						return message.provider.includes(this.messageProvider) && message.status === 'ready'
					return message.status === 'ready'
				})
				.sort((a, b) => (a.time - b.time))
		}
	},

	components: {
		MessageList,
		ProviderSelect
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.header-icon {
	height: 43px !important;
	margin-top: -1px !important;
}
</style>
